import * as React from "react";
import { Empty } from '@bedrock/components'
import './style.less'
import NoData from '@bedrock/components/es/Empty/images/small/NoData';

const prefixCls = 'MPCTableEmpty'

const MPCTableEmpty = (props: { text?: string }) => {
  return (
    <div className={prefixCls}>
      <NoData />
      <div className={`${prefixCls}-text`}>{props.text || '暂无数据'}</div>
    </div>
  )
}

export default MPCTableEmpty;